export default function jwtDecode(jwt: string): JwtPayload | null {
  try {
    return JSON.parse(atob(jwt.split('.')[1]))
  } catch (decodeError) {
    return null
  }
}
